import React, { FC } from 'react'

const DesignIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.3702 4.17149C23.0502 2.88697 21.6598 1.4965 20.3752 2.17654L13.1053 6.02534C11.2202 7.02335 9.76681 8.66605 9.00223 10.6418C8.80419 11.1536 9.05553 11.7293 9.56545 11.932C10.936 12.4767 11.9828 13.5929 12.5152 15.001C12.7099 15.5158 13.2838 15.7765 13.7996 15.5845C15.8223 14.8313 17.5057 13.3599 18.5214 11.4415L22.3702 4.17149Z"
      fill="currentColor"
    />
    <path
      d="M10.0082 14.4606C8.39792 12.8502 5.87632 12.9122 4.45429 14.6388C3.95834 15.2409 3.81935 15.8713 3.74214 16.3536C3.72305 16.4729 3.70766 16.5775 3.69389 16.6712L3.69346 16.6741C3.64653 16.9935 3.61828 17.1857 3.52572 17.399C3.35827 17.785 2.93862 18.0417 2.51735 18.0136C2.14919 17.989 1.7974 18.1691 1.60216 18.4822C1.40691 18.7953 1.39994 19.1905 1.58402 19.5103C3.36443 22.6032 7.82811 22.8497 9.96525 20.0663C10.5178 19.3467 10.962 18.4199 11.0589 17.4318C11.1589 16.4126 10.8831 15.3355 10.0082 14.4606Z"
      fill="currentColor"
    />
  </svg>
)

export default DesignIcon
